<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" :animated="false">
      <TabPane name="1" label="发票申请" v-if="p('invoice/list')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="专票资质审核" v-if="p('invoice/invoiceCompetency/list')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="业主发票申请" v-if="p('invoice/downloadInvoiceList')">
        <c3></c3>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/invoiceManage/invoiceApply/index'
  import C2 from '@/views/invoiceManage/specialReview/index'
  import C3 from '@/views/invoiceManage/proInvoiceApply/index'
  import {mixin} from "../../mixin";

  export default {
    name:'order',
    components:{
      C1,
      C2,
      C3,
    }        ,
    mixins:[mixin],
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
